module.exports = __webpack_public_path__ + "static/specialAOP (3)-609285f1e70be0e249d87eed324a95f9.png";